import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { InfoTooltip } from '@/shared/components/Tooltip';

interface Props {
  labelId?: string;
  label?: ReactNode;
  tooltipId?: string;
  htmlFor?: string;
  className?: string;
  optional?: boolean;
  variant?: 'uppercase' | 'plain';
}

export default function FieldLabel({
  labelId,
  label,
  tooltipId,
  htmlFor,
  className,
  optional,
  variant = 'uppercase',
}: Props) {
  const labelContent = labelId ? <FormattedMessage id={labelId} /> : label;
  if (!labelContent) {
    return null;
  }

  return (
    <div className={`mb-3 flex items-center gap-2 ${className ?? ''}`.trim()}>
      <label htmlFor={htmlFor} className={labelClass(variant)}>
        {labelContent}
      </label>
      {optional && (
        <span className="text-xs font-medium normal-case tracking-normal text-slate-400">
          <FormattedMessage id="common.optional" />
        </span>
      )}
      {tooltipId && (
        <InfoTooltip content={<FormattedMessage id={tooltipId} />} />
      )}
    </div>
  );
}

function labelClass(variant: NonNullable<Props['variant']>): string {
  return variant === 'plain'
    ? 'text-sm font-semibold text-slate-700'
    : 'text-xs font-semibold uppercase tracking-[0.1em] text-slate-500';
}
